import { c as o } from "./createLucideIcon-BuuoCVvz.js";
/**
 * @license lucide-react v0.503.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const n = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], e = o("chevron-down", n);
export {
  e as C
};
//# sourceMappingURL=chevron-down-DbW0ZdOK.js.map
